import { render, staticRenderFns } from "./NDEEtuiCardChristmasModal.vue?vue&type=template&id=e90efbc4&scoped=true&"
import script from "./NDEEtuiCardChristmasModal.vue?vue&type=script&lang=js&"
export * from "./NDEEtuiCardChristmasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90efbc4",
  null
  
)

export default component.exports